export const MAX_SUGGESTIVE_SELLING_CHAIN_DEPTH = 5;

export const CROSS_SALES_ENRICH_CONCURRENCY = 5;

/** Grid layout for compact cards in the dialog. */
export const SUGGESTIVE_SELLING_GRID_COLUMNS = 6;

/** Fixed virtual row height (card + gap). */
export const SUGGESTIVE_SELLING_VIRTUAL_ROW_HEIGHT = 148;

/** Use row virtualization when a category has more than this many items. */
export const SUGGESTIVE_SELLING_VIRTUALIZE_THRESHOLD = 40;

export const SuggestiveSellingDataGridColumnNames = {
    select: 'select',
    part: 'part',
    description: 'description',
    price: 'price',
    quantity: 'quantity',
} as const;

export const suggestiveSellingDataGridSaveConfig = {
    name: 'SuggestiveSellingDialogDataGrid',
    version: 1,
};

export const SUGGESTIVE_SELLING_VIEW_MODES = {
    grid: 'grid',
    list: 'list',
};
